import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AppService } from '../../../core/services/app.service';
import { CryptoService } from '../../../core/services/crypto.service';
import { LocalStorageService } from '../../../core/services/local-storage.service';

@Injectable({
    providedIn: 'root'
})
export class CamerallaBypass {
    public dataKey = 'camerallaUser';
    authApi = AppService.getApiUrl() + '/api/customers/auth';

    constructor(private localStorage: LocalStorageService, private cryptoService: CryptoService) {
    }

    private getLocalUserObject() {
        return this.cryptoService.decrypt(this.localStorage.getItem(this.dataKey));
    }

    private setLocalUserObject(data) {
        this.localStorage.setItem(this.dataKey, this.cryptoService.encrypt(data));
    }

    login(code) {
        const cameralla_id = environment['auth']['user']['id'];
        const wp_id = environment['auth']['user']['wp_id'];
        const accessToken = environment['auth']['user']['access_token'];

        this.setLocalUserObject({id: cameralla_id, wp_id: wp_id, accessToken: accessToken});

        return Promise.resolve(true);
    }

    public logout() {
        this.localStorage.removeItem(this.dataKey);

        return Promise.resolve(true);
    }

    public isAuthenticated() {
        return !!this.localStorage.getItem(this.dataKey);
    }

    public getLocalUserInfo() {
        return this.getLocalUserObject();
    }
}
